import { ButtonGroup, ButtonT5 } from "Components/Common/Button/index";
import React, { Fragment } from "react";

const StatusTab = (props) => {
  const { statusTabBtnList = [], handleOnClickStatusTabBtn } = props;

  if (statusTabBtnList.length <= 0) {
    return;
  }

  return (
    <Fragment>
      <ButtonGroup>
        {statusTabBtnList.map((ele) => {
          if(!ele.isVisible){
            return null;
          }
          return (
            <Fragment key={ele.id}>
              <ButtonT5
                active={ele.isActive}
                minWidth={"100px"}
                onClick={() => {
                  handleOnClickStatusTabBtn(ele.id);
                }}
              >
                {`${ele.name} (${ele.count})`}
              </ButtonT5>
            </Fragment>
          );
        })}
      </ButtonGroup>
    </Fragment>
  );
};

export default StatusTab;
